// extracted by mini-css-extract-plugin
export var askAiIcon = "_mv-j";
export var category = "_mv-9";
export var categoryHeader = "_mv-e";
export var container = "_mv-0";
export var group = "_mv-a";
export var groupItems = "_mv-f";
export var groupSeparator = "_mv-k";
export var loading = "_mv-1";
export var noResults = "_mv-3";
export var placeholder = "_mv-2";
export var resultContent = "_mv-5";
export var resultIcon = "_mv-c";
export var resultItem = "_mv-g";
export var resultMeta = "_mv-8";
export var resultSubtitle = "_mv-7";
export var resultSuffix = "_mv-i";
export var resultTitle = "_mv-6";
export var resultsList = "_mv-4";
export var searchGroup = "_mv-d";
export var selected = "_mv-h";
export var subgroup = "_mv-b";